import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import './Carousel.css';
import { formatCaption } from '../../utils/textFormatting';

function InstagramMobilePostView({ post, onClose }) {
  if (!post) return null;

  return (
    <div 
      className="fixed inset-0 bg-white z-50 overflow-y-auto"
      aria-labelledby="mobile-post-title"
    >
      {/* Header with back button */}
      <div className="flex items-center p-4 border-b border-gray-200 bg-white">
        <button
          onClick={() => {
            window.history.back();
            onClose();
          }}
          className="mr-4"
          aria-label="Back"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <div className="flex items-center">
          <img
            src="/the-dorcol-profile.jpg"
            alt="The Dorcol Residence Logo"
            className="w-10 h-10 rounded-full border border-gray-300 object-cover"
          />
          <div className="ml-3 flex flex-col">
            <div className="flex items-center">
              <span className="font-semibold text-sm" id="mobile-post-title">thedorcolresidence</span>
              <img 
                src="/verified.png" 
                alt="Verified" 
                className="w-4 h-4 ml-1"
                aria-hidden="true"
              />
            </div>
            <span className="text-xs text-gray-500 -mt-0.5">Belgrade</span>
          </div>
        </div>
      </div>

      {/* Media section */}
      <div className="w-full bg-black flex items-center justify-center">
        {post.videoUrl ? (
          <video
            src={post.videoUrl}
            poster={post.thumbnailUrl}
            className="max-w-full max-h-full object-contain"
            autoPlay
            controls
            loop
            playsInline
            aria-label={post.caption || 'Instagram video post'}
          >
            <track kind="captions" src="" label="English" />
          </video>
        ) : post.isVideo ? (
          <video
            src={post.mediaUrl}
            className="max-w-full max-h-full object-contain"
            autoPlay
            controls
            playsInline
            aria-label={post.caption || 'Instagram video post'}
          >
            <track kind="captions" src="" label="English" />
          </video>
        ) : post.hasMultipleImages ? (
          <Swiper
            modules={[Pagination]}
            pagination={{
              clickable: true,
              dynamicBullets: true,
            }}
            className="w-full h-full"
          >
            {post.mediaUrls.map((url, index) => (
              <SwiperSlide key={index} className="flex items-center justify-center h-full">
                <img
                  src={url}
                  alt={`${post.caption || 'Instagram post'} #${index + 1}`}
                  className="max-w-full max-h-full object-contain"
                />
              </SwiperSlide>
            ))}
          </Swiper>
        ) : (
          <img
            src={post.thumbnailUrl || post.mediaUrl}
            alt={post.caption || 'Instagram image post'}
            className="max-w-full max-h-full object-contain"
          />
        )}
      </div>

      {/* Content area */}
      <div className="bg-white">
        {/* Action buttons */}
        <div className="p-4 border-b border-gray-200">
          <div className="flex items-center">
            <div className="flex space-x-4">
              <button className="bg-transparent border-0 p-0" aria-label="Like">
                <svg className="w-6 h-6 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                </svg>
              </button>
              <button className="bg-transparent border-0 p-0" aria-label="Comment">
                <svg className="w-6 h-6 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                </svg>
              </button>
              <button className="bg-transparent border-0 p-0" aria-label="Share">
                <svg className="w-6 h-6 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
                </svg>
              </button>
            </div>
            <button className="bg-transparent border-0 p-0 ml-auto" aria-label="Save">
              <svg className="w-6 h-6 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.5L5 21V5z" />
              </svg>
            </button>
          </div>
        </div>

        {/* Caption */}
        <div className="p-4">
          <div className="flex mb-2">
            <img
              src="/the-dorcol-profile.jpg"
              alt="The Dorcol Residence Logo"
              className="w-10 h-10 rounded-full border border-gray-300 object-cover"
            />
            <div className="ml-3">
                              <span className="font-semibold text-sm">thedorcolresidence </span>
              <span className="text-sm text-gray-900">{post.caption?.trim() ? formatCaption(post.caption) : <em className="text-gray-400">Copy being added…</em>}</span>
              <div className="text-xs text-gray-500 mt-1">{post.date}</div>
            </div>
          </div>
        </div>

        {/* Approve or Approved Post */}
        {post.approved ? (
          <div className="text-green-600 text-center font-semibold py-2">Approved Post</div>
        ) : (
          <div className="flex flex-col gap-2 p-4">
            <a
              href={post.browserLink ? `${post.browserLink}&view=center` : '#'}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-gray-300 hover:bg-gray-400 text-gray-800 text-sm py-2 px-4 rounded w-full flex items-center justify-center"
            >
              ✅ Approve Post
            </a>
            <a
              href={post.browserLink ? `${post.browserLink}&view=center` : '#'}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-blue-500 hover:bg-blue-600 text-white text-sm py-2 px-4 rounded w-full flex items-center justify-center"
            >
              ✏️ Edit Post
            </a>
          </div>
        )}
      </div>
    </div>
  );
}

export default InstagramMobilePostView;
